
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Dialog } from "element-ui";
Vue.use(Dialog);

@Component
export default class GsDialog extends Vue {
  @Prop() value = false;
  // @Prop() switchStyle = true;
  @Prop({ default: "标题" }) title;
  @Prop({ default: "500px" }) width;
  @Prop({ default: "1000px" }) height;
  @Prop({ default: "15vh" }) top;
  @Prop({ default: false }) disabled;
  @Prop({ default: "rgb(231, 231, 231)" }) cancelButtonColor: string;
  @Prop() type;

  isVisible = false;

  @Watch("value")
  onValueChange() {
    this.isVisible = this.value;
  }

  @Watch("isVisible")
  onIsVisibleChange() {
    if (this.isVisible === false) {
      this.$emit("input", false);
    }
  }

  cancelClick() {
    this.isVisible = false;
    this.$emit("cancel");
  }

  mouseover() {}

  mouseleave() {}

  mounted() {}
}
